var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","flex-direction":"column","height":"100vh"}},[_c('app-header'),_c('app-main',{staticClass:"main"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }